import { requiredMessage } from 'validation'
import * as yup from 'yup'

export const CREATE_REPORT_SCHEMA = yup.object().shape({
  template: yup.mixed(),
  sqlQuery: yup.string().required(requiredMessage)
})